import React, { useState } from "react";
import PaySourceRow from "./PaySourceRow";

/** One Pay Source group (Invoiced / Self-logs / Unassigned) with a 'Missing this week' filter and a name search. */
export default function PaySourceList({ data, group, onChanged }) {
  const [missing, setMissing] = useState(false);
  const [q, setQ] = useState("");
  const rows = data.rows.filter((r) => r.group === group && (!missing || r.status === "missing") && (!q.trim() || r.name.toLowerCase().includes(q.trim().toLowerCase())));
  return (
    <div className="space-y-3" data-testid={`ps-list-${group}`}>
      <div className="flex flex-wrap items-center gap-3">
        <label className="inline-flex items-center gap-1.5 text-[11px] text-nex-muted"><input type="checkbox" checked={missing} onChange={(e) => setMissing(e.target.checked)} data-testid="ps-filter-missing" /> Missing this week</label>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search resident…" data-testid="ps-search"
          className="w-48 px-2 py-1 bg-black/40 border border-white/10 focus:border-nex-gold/60 outline-none text-nex-silver text-xs rounded-sm" />
        <span className="ml-auto font-mono text-[10px] text-nex-muted" data-testid="ps-week">Week {data.week.start} → {data.week.end} · {rows.length} shown</span>
      </div>
      {group === "unassigned" && <p className="text-[11px] text-nex-muted">Active residents with no invoice and no paycheck history. Pin them to Invoiced or Self-logs.</p>}
      {rows.length ? (
        <ul className="divide-y divide-white/5 border-y border-white/5">
          {rows.map((r) => <PaySourceRow key={r.resident_id} row={r} canPin={data.can_pin} canRemind={data.can_remind} onChanged={onChanged} />)}
        </ul>
      ) : <p data-testid="ps-empty" className="text-sm text-nex-muted py-6">Nobody here{missing ? " is missing this week" : ""}.</p>}
    </div>
  );
}
